<template>
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="变压器用电情况" name="first" lazy>
      <bianyaqi :date="date" :dateType="dateType"></bianyaqi>
    </el-tab-pane>
    <el-tab-pane label="馈线回路用电统计（前十）" lazy name="second">
      <huilu :date="date" :dateType="dateType"></huilu>
    </el-tab-pane>
    <el-tab-pane label="负载类别统计" lazy name="third">
      <fuzai :date="date" :dateType="dateType"></fuzai>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
  import bianyaqi from "./ydtj/bianyaqi";
  import huilu from "./ydtj/huilu";
  import fuzai from "./ydtj/fuzai";
  export default {
    name: "ztgy",
    data () {
      return {
        activeName: 'first'
      };
    },
    props: {
      date: {
        type: String
      },
      dateType: {
        type: String
      },
    },
    components: { bianyaqi, huilu, fuzai },
    mounted () {

    },
    computed: {

    },
    watch: {

    },
    methods: {
      handleClick (tab, event) {
        console.log(tab, event);
      },
    },
  };
</script>

<style lang="less">
  .el-tabs {
    .el-tabs__header {
      margin: 0 0 1px;

      .el-tabs__nav-wrap {
        padding-left: 20px;
        background: #f8f8f9;
      }
    }
  }
</style>